import { SupportedLanguage } from 'core/hooks/languages';

export const toLanguageText = (languages: SupportedLanguage[], value: string): string =>
  languages.find(language => language.value === value)?.text ?? value;
